import React, { Component } from 'react';
import { observer } from "mobx-react";
import _ from 'lodash';

import loader from "../images/loader.svg";

import { DataTable } from '../tables/Tables';
import { dashboardsTitles, errors, buttonTitles } from '../dictionary';
import { uistate, pushState } from '../stores/common';
import { ArrowIcon } from '../images/icons';
import { TablePageContent } from '../shared/TableComponents';

export class TableFilterPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen : false,
			Filter : this.props.Filter
		}
	}

	toggleFilter (event) {
		event.preventDefault();
		this.setState({ isOpen : !this.state.isOpen });
	}

	setFilter (event) {
		event.preventDefault();
		var filter = event.target.getAttribute("rel");
		this.props.setFilter(filter);
	}

	render() {
		var view = this;

        return(
			<section className="listpage">
				<div className={"head " + (uistate.IsMobile ? "mobile" : "")}>
					<h2>
						{dashboardsTitles[this.props.Type] || this.props.Type}
						{!_.isEmpty(this.props.HeadFilter) && 
							_.map(this.props.HeadFilter, function(value, name) {
								return(<a href="/" className="toggleActive" onClick={view.setFilter.bind(view)} 
									rel={name} key={name}>{buttonTitles[(value ? "not" : "") + name + view.props.Type]}</a>)
							})
						}
					</h2>
					{this.props.CanManage && (_.isUndefined(this.props.HideAddButton || this.props.HideAddButton)) &&
						<button className="add blue" onClick={(e) => { this.props.setId(-1) }}>
							{uistate.IsMobile ? "Добавить" : buttonTitles[this.props.Type] || "Добавить"}</button>
					}
				</div>
				<TablePageContent {...this.props} />
			</section>
        )
    }
}
TableFilterPage = observer(TableFilterPage);

export class ItemHeader extends Component {
	render() {
		var style = { left : uistate.IsTablet ? 50 : uistate.IsSideBarOpen ? 260 : 50 }
		
		return(
			<div className={"head " + (uistate.IsMobile ? "mobile" : "")} style={style}>
				<h2>{this.props.Title}</h2>
				{this.props.Error !== "" && <p className={this.props.Success ? "success" : "error"}>
					{errors[this.props.Error] || errors.DEFAULT}</p>}
				<div>

					{this.props.CanManage &&
						<button className={this.props.Loading ? "loading" : ""} disabled={this.props.Loading}>
							{this.props.Loading && <img src={loader} alt="loading" /> }
							{!this.props.Loading && "Сохранить" }
						</button>
					}
					{this.props.CanAccept &&
						<a href="/" className={"green button " + (this.props.Loading ? "loading" : "")} 
							disabled={this.props.Loading} onClick={this.props.onAccept}>
							{this.props.Loading && <img src={loader} alt="loading" /> }
							{!this.props.Loading && "Сохранить и подтвердить" }
						</a>
					}
					{this.props.CanSend &&
						<a href="/" className={"green button " + (this.props.Loading ? "loading" : "")} 
							disabled={this.props.Loading} onClick={this.props.onSend}>
							{this.props.Loading && <img src={loader} alt="loading" /> }
							{!this.props.Loading && "Сохранить и отправить" }
						</a>
					}
					{(_.isUndefined(this.props.HideClose) || this.props.HideClose === false) &&
						<a href="/" className="button close" onClick={this.props.handleClose}>Назад</a>
					}
				</div>
				
			</div>
		)
	}
}
ItemHeader = observer(ItemHeader);

export class TableReportPage extends Component {
    render() {
		var hasPagination = this.props.HasMore || this.props.Offset > 0,
			hasPaginationNumber = this.props.Total > this.props.Limit;

        return(
			<section className="listpage">
				<DataTable
					Data={this.props.TableData}
					Columns={this.props.TableColumns}
					Type={this.props.Type}
					IsFilterable={this.props.TableFilterable}
					IsSortable={this.props.IsSortable}
					ClassName="reportTable"

					editRow={this.props.editRow}
					removeRow={this.props.removeRow}
					changeRowState={this.props.payRow}
					download={(id) => this.props.downloadList(id)}

					SubComponent={this.props.SubComponent}
					getTrProps={this.props.getTrProps}
					checkRow={this.props.checkRow}
				/>
				{this.props.Pagination && hasPagination && this.props.PaginationType !== "number" &&
					<TablePagination
						Limit={this.props.Limit}
						HasMore={this.props.HasMore}
						Offset={this.props.Offset}
						changePage={this.props.changePage}
					/>
				}
				{this.props.Pagination && hasPaginationNumber && this.props.PaginationType === "number" &&
					<TablePaginationNumber
						Limit={this.props.Limit}
						// HasMore={this.props.HasMore}
						Total={this.props.Total}
						Offset={this.props.Offset}
						changePage={this.props.changePage}
					/>
				}
			</section>
        )
    }
}
TableReportPage = observer(TableReportPage);

export class TablePagination extends Component {
	render() {
		return(
			<div className="pagination">
				{this.props.Offset > 0
					? <button type="button" className="prev"
						onClick={() => this.props.changePage(this.props.Offset - this.props.Limit)}>
						<ArrowIcon />Предыдущие {this.props.Limit}</button>
					: <span className="placeholder" />
				}
				{this.props.HasMore &&
					<button type="button" className="next"
						onClick={() => this.props.changePage(this.props.Offset + this.props.Limit)}>
						Следующие {this.props.Limit}<ArrowIcon /></button>
				}
			</div>
		)
	}
}

export class TablePaginationNumber extends Component {
	/** Обработка клика на переключение между страницами таблицы */
	handleClick(event) {
		event.preventDefault();
		var offset = parseInt(event.currentTarget.getAttribute("rel"), 10);

		if (this.props.changePage) this.props.changePage(offset);
	}

	render() {
		var view = this,
			totalPages = Math.ceil(this.props.Total/this.props.Limit),
			activePage = this.props.Offset/this.props.Limit + 1,
			maxPages = 9,
			shiftPage = 4,
			startPageNumber = activePage < shiftPage ? 1 : activePage > (totalPages - shiftPage)
				? totalPages - maxPages + 1 : activePage - shiftPage,
			prev = this.props.Offset - this.props.Limit,
			next = this.props.Offset + this.props.Limit,
			lastPage = (totalPages - 1)*this.props.Limit,
			pages = _.range(startPageNumber, startPageNumber + maxPages);

		return(
			<div className="pagination numbers">
				<a href="/" className="icon start" title="К первой странице" rel="0"
					onClick={this.handleClick.bind(this)}><i></i></a>
				{activePage > 1 &&
					<a href="/" className="icon prev" title="Предыдущая страница" rel={prev}
						onClick={this.handleClick.bind(this)}><i></i></a>
				}
				{_.map(pages, function(v) {
					return(<a href="/" className={"icon number " + (v === activePage ? "active" : "")} 
						title={"Страница " + v} rel={(v - 1)*view.props.Limit} key={v}
						onClick={view.handleClick.bind(view)}><i>{v}</i></a>)
				})}
				{activePage < totalPages &&
					<a href="/" className="icon next" title="Следующая страница" rel={next}
						onClick={this.handleClick.bind(this)}><i></i></a>
				}
				<a href="/" className="icon end" title="Последняя страница" rel={lastPage}
					onClick={this.handleClick.bind(this)}><i></i></a>
			</div>
		)
	}
}

export class PushBlock extends Component {
	render() {
		return(
			<div id="pushMessage">
				{_.map(pushState.Push, function (push, i) {
					return(<PushMessage key={"p" + i} Index={i} Item={push}/>)
				})}
			</div>
		)
	}
}
PushBlock = observer(PushBlock);

export class PushMessage extends Component {
	onClick (event) {
		event.preventDefault();

		var index = this.props.Index;
		pushState.Push = _.filter(pushState.Push, function (v,i) { return i !== index; });
	}

	render() {
		return(
			<div className="message">
				<h5>{this.props.Item.Title}</h5>
				<p>{this.props.Item.Message}</p>
				<a href="/" onClick={this.onClick.bind(this)} className="close"><i></i></a>
			</div>
		)
	}
}
PushMessage = observer(PushMessage);
